import { roles } from '@nxsys/store/constants';
import { Navigate } from 'react-router-dom';
import XeroJournalPage from '../../../modules/accounting/xero/XeroJournalPage';

// NX-5235 — Accounting › Xero. `/accounting` lands on the only child;
// Sage / QuickBooks would become sibling routes.
export const accountingConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/accounting',
    element: <Navigate to="/accounting/xero" replace />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/accounting/xero',
    element: <XeroJournalPage />,
  },
];
